export const FETCH_ACUMATICA_FAILURE_LOGS_REQUEST = 'FETCH_ACUMATICA_FAILURE_LOGS_REQUEST';
export const FETCH_ACUMATICA_FAILURE_LOGS_SUCCESS = 'FETCH_ACUMATICA_FAILURE_LOGS_SUCCESS';
export const FETCH_ACUMATICA_FAILURE_LOGS_FAILURE = 'FETCH_ACUMATICA_FAILURE_LOGS_FAILURE';